import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { ThemeProvider } from './theme/ThemeContext';
import MainLayout from './components/layout/MainLayout';
import ScenarioRedirect from './components/scenarios/ScenarioRedirect';
import CampaignsPage from './components/campaigns/CampaignsPage';
import MailingFlowEditorPage from './components/mailing-constructor/MailingFlowEditorPage';
import RequireAuth from './components/RequireAuth';

function LegacyCampaignEditRedirect() {
  const { id } = useParams();
  if (!id || id === 'new') {
    return <Navigate to="/" replace />;
  }
  return <Navigate to={`/?settings=${encodeURIComponent(id)}`} replace />;
}

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<RequireAuth />}>
            <Route path="/" element={<MainLayout />}>
              <Route index element={<CampaignsPage />} />
              <Route path="scenarios" element={<Navigate to="/?tab=scenarios" replace />} />
              <Route path="scenarios/:id" element={<ScenarioRedirect />} />
              <Route path="campaigns" element={<Navigate to="/" replace />} />
              <Route path="campaigns/:id" element={<LegacyCampaignEditRedirect />} />
              <Route path="visual" element={<Navigate to="/?tab=scenarios" replace />} />
              <Route path="mailing/:id" element={<MailingFlowEditorPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
